import React from 'react'

import { useTranslation } from 'react-i18next'

import Divider from '@layout/Divider'
import SideNavItem from '@layout/SideNavMenu/SideNavItem'
import { useSession } from '@stores/globalData/globalData.store'
import { PRESS_LINK } from '@utils/global'

const CompanyNav: React.FC = () => {
  const { t } = useTranslation()
  const session = useSession()
  return (
    <>
      <Divider />
      <p className="font-medium text-base ml-2 mb-2">{t('siteSidebar.company')}</p>
      <SideNavItem
        href="/company/about"
        external
        label={t('siteSidebar.about')}
        iconName="nf-info-lt"
      />
      <SideNavItem
        href="/company/team"
        external
        label={t('siteSidebar.team')}
        iconName="nf-info-lt"
      />
      <SideNavItem
        href="/company/jobs"
        external
        label={t('siteSidebar.jobs')}
        iconName="nf-info-lt"
      />
      <SideNavItem
        href={PRESS_LINK}
        external
        label={t('siteSidebar.press')}
        iconName="nf-info-lt"
      />
      {session.current_user && session.community.default_community && (
        <SideNavItem href="/site" external label={t('siteSidebar.home')} iconName="nf-home" />
      )}
    </>
  )
}

export default CompanyNav
